import React from 'react'
import { TimelineSpanParent } from '../../domain/TimelineSpan'
import { TraceSpanCategory } from '../../domain/Trace'
import Link from '../../helper/link'
import Shorten from '../../helper/shorten'

interface Props {
    parents: TimelineSpanParent[]
    categories: { [category: string]: TraceSpanCategory }
    route: string
}

export class ParentSpansList extends React.Component<Props> {
    public render() {
        const { parents, categories, route } = this.props
        if (!parents.length) {
            return null
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>Parent Spans</h4>
                </div>
                <div className="col-md-12">
                    <ul className="list-unstyled">
                        {parents.map(parent => {
                            const category = spanParentCategory(parent, categories)
                            const name = category.label === 'Event' ? parent.event?.name : parent.span.name

                            return (
                                <li key={spanParentKey(parent)}>
                                    <Link route={route} query={spanParentQueryParameters(parent)}>
                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className={'category category-' + category.className} style={{ marginBottom: '2px' }}>
                                                    {category.label}
                                                </div>
                                            </div>
                                            <div className="col-md-10">
                                                <Shorten string={name} />
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}

const spanParentIdentifier = (parent: TimelineSpanParent): string => {
    const categoryIdentifier = parent.span.cat
    if (!categoryIdentifier && parent.span.span && parent.span.span.cat) {
        return parent.span.span.cat
    }

    return categoryIdentifier
}

const spanParentKey = (parent: TimelineSpanParent): string => {
    if (parent.event) {
        return parent.event.span ? 'parent_' + parent.event.span.id + '_' + parent.event.cs : 'parent_' + parent.event.cs
    }

    return parent.span.span ? 'parent_' + parent.span.span.id + '_' + parent.span.cs : 'parent_' + parent.span.id
}

const spanParentCategory = (parent: TimelineSpanParent, categories: { [category: string]: TraceSpanCategory }): TraceSpanCategory => {
    if (parent.event) {
        return { className: 'event', label: 'Event' }
    }

    const categoryIdentifier = spanParentIdentifier(parent)
    if (categoryIdentifier in categories) {
        return categories[categoryIdentifier]
    }
    const components = categoryIdentifier.split(/\./g)
    if (components[0] in categories) {
        return categories[components[0]]
    }

    return { className: 'unknown', label: 'Unknown' }
}

const spanParentQueryParameters = (parent: TimelineSpanParent): object =>
    parent.event ? { span: parent.span.id, e: parent.event.cs } : { span: parent.span.id }
